import React from "react";
import { gql } from "apollo-boost";
import { useMutation } from "@apollo/react-hooks";
import { SC_sc } from "../../SC/__generated__/SC";
import _ from "lodash";
import { Row, Col, Button } from "antd";
import { SCRULER_ruler_tech } from "../__generated__/SCRULER";

const TECHNOLOGYADVANCETECH = gql`
  mutation TECHNOLOGYADVANCETECH($sc: ID!, $item: String!, $newTech: Int!) {
    advanceTech(sc: $sc, item: $item, newTech: $newTech) {
      sc
    }
  }
`;

interface Props {
  sc: SC_sc;
  tech: SCRULER_ruler_tech[];
  reload: any;
  reload2: any;
}

export const Technology = ({ sc, tech, reload, reload2 }: Props) => {
  const [changeStatus] = useMutation(TECHNOLOGYADVANCETECH);

  const handleChangeStatus = async (
    sc: string,
    item: string,
    newTech: number
  ) => {
    await changeStatus({ variables: { sc, item, newTech } });
    reload();
    reload2();
  };

  const rsch = _.find(sc.non, { item: "RSCH" });
  const rschAvailable = rsch ? rsch.amount : 0;

  const techEntry = (tech: SCRULER_ruler_tech) => {
    if (rschAvailable >= tech.tl * 1000000) {
      return (
        <Col
          key={tech.item + tech.tl}
          style={{ textAlign: "center" }}
          xs={{ span: 24 }}
          sm={{ span: 12 }}
          md={{ span: 8 }}
          lg={{ span: 6 }}
          xl={{ span: 4 }}
          xxl={{ span: 2 }}
        >
          {
            <Button
              onClick={() => {
                handleChangeStatus(sc.sc, tech.item, tech.tl + 1);
              }}
            >
              {tech.item}-{tech.tl}
            </Button>
          }
        </Col>
      );
    } else {
      return (
        <Col
          key={tech.item + tech.tl}
          style={{ textAlign: "center" }}
          xs={{ span: 24 }}
          sm={{ span: 12 }}
          md={{ span: 8 }}
          lg={{ span: 6 }}
          xl={{ span: 4 }}
          xxl={{ span: 2 }}
        >
          {tech.item}-{tech.tl}
        </Col>
      );
    }
  };

  var children: JSX.Element[] = [];

  children.push(<h3 key={"Technology"}>Research / Technology</h3>);
  let entries: JSX.Element[] = [];
  tech.forEach((q) => {
    entries.push(techEntry(q));
  });

  children.push(<Row key="Technology Row">{entries}</Row>);

  return <div>{children}</div>;
};
